"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var height = "3rem";

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n"])));

var StyledTriangle = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  transform: translateX(-50%);\n  border: ", " solid transparent\n  border-left: ", " solid transparent;\n  border-right: ", " solid transparent;\n  border-top: ", " solid ", ";\n  width: calc(", " * 2);\n  height: ", ";\n"])), height, height, height, height, function (p) {
  return p.theme.colorPrimary;
}, height, height);

var StyledContent = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 1;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  padding: 0 0.5rem 0 1.25rem;\n  width: 9rem;\n  background: ", ";\n"])), function (p) {
  return p.theme.colorPrimary;
});

var StyledPrizePoolLabel = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: 0.575rem;\n  font-weight: 400;\n  margin-bottom: 2px;\n  color: ", ";\n"])), function (p) {
  return (0, _polished.rgba)(p.theme.colorPrimaryText, 0.67);
});

var StyledPrizepool = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: 1.5rem;\n  color: ", ";\n"])), function (props) {
  return props.theme.colorPrimaryText;
});

var StyledAlert = (0, _styledComponents.default)(_fiverReactUiComponents.Alert)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  width: 90%;\n  margin: 0 auto 1rem;\n"])));

var ContestBannerPrizepool = function ContestBannerPrizepool(_ref) {
  var activePickem = _ref.activePickem,
      app = _ref.app;
  var isActivePickemInPlay = (activePickem === null || activePickem === void 0 ? void 0 : activePickem.status) === "IN_PLAY";
  var isActivePickemApproved = (activePickem === null || activePickem === void 0 ? void 0 : activePickem.status) === "APPROVED";
  var walletBalance = app.walletBalance,
      walletPromoBalance = app.walletPromoBalance;

  var _useSelector = (0, _reactRedux.useSelector)(function (s) {
    return s.contest;
  }),
      translations = _useSelector.translations;

  var prizePool = (activePickem === null || activePickem === void 0 ? void 0 : activePickem.prizeFund) || (activePickem === null || activePickem === void 0 ? void 0 : activePickem.promoPrizeFund);
  var hasPromoPrize = (activePickem === null || activePickem === void 0 ? void 0 : activePickem.promoPrizeFund) > 0;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledWrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledContent, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledPrizePoolLabel, {
        children: [prizePool === undefined && /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.Skeleton, {
          skeletonColorBackground: "rgba(255, 255, 255, 0.24)",
          skeletonColorShimmer: "rgba(255, 255, 255, 0.12)",
          skeletonHeight: "10px",
          skeletonWidth: "60px"
        }), prizePool !== undefined && hasPromoPrize ? "".concat(translations.total, " ").concat(translations.promoPrize) : prizePool !== undefined ? "".concat(translations.total, " ").concat(translations.prizePool) : null]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledPrizepool, {
        children: [prizePool !== undefined && /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.PenceToPounds, {
            isDutch: true,
            hideDecimals: true,
            showCurrencySymbol: true,
            children: prizePool
          })
        }), prizePool === undefined && /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.Skeleton, {
          skeletonColorBackground: "rgba(255, 255, 255, 0.24)",
          skeletonColorShimmer: "rgba(255, 255, 255, 0.12)",
          skeletonHeight: "24px",
          skeletonWidth: "100px"
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTriangle, {})]
  });
};

var _default = ContestBannerPrizepool;
exports.default = _default;